import React from 'react';
import { Link } from 'react-router-dom';
import logo from 'views/Images/logo4.png';

function MainFooter() {
	return (
		<footer className='landing-footer'>
			<div className='landing-footer__top'>
				<div>
					<Link className='landing-footer__brand' to='/landing'>
						<img src={logo} alt='Weciny Logo' />
						<span>Weciny</span>
					</Link>
					<p>
						Helping local businesses grow through community connections and
						AI-powered automation.
					</p>
				</div>

				<div className='landing-footer__columns'>
					<div>
						<h3>Platform</h3>
						<a href='#features'>Features</a>
						<a href='https://weciny.com'>Residential Platform</a>
						<a href='#pricing'>Pricing</a>
					</div>
					<div>
						<h3>Company</h3>
						<Link to='/about-us'>About Us</Link>
						<Link to='/contact-us'>Contact Us</Link>
						<Link to='/terms'>Terms & Privacy</Link>
					</div>
				</div>
			</div>
			<div className='landing-footer__bottom'>
				<span>© {new Date().getFullYear()} Weciny. All rights reserved.</span>
				<span>
					Built for service providers, creators, and neighborhood commerce.
				</span>
			</div>
		</footer>
	);
}

export default MainFooter;
